import React from 'react';
import './SectionHeader.css';

interface SectionHeaderProps {
	title: string;
	subtitle?: string;
	align?: 'left' | 'center';
	as?: 'h1' | 'h2' | 'h3';
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
	title,
	subtitle,
	align = 'center',
	as: Tag = 'h2',
}) => {
	return (
		<div className={`section-header section-header--${align}`}>
			<Tag className="section-header__title">{title}</Tag>
			{subtitle && <p className="section-header__subtitle">{subtitle}</p>}
			<div className="section-header__accent" />
		</div>
	);
};

export default SectionHeader;
